import { StatusCodes } from "http-status-codes";
import { NA, NO_DATA_FOUND_PLEASE_TRY_AGAIN, SOMETHING_WENT_WRONG, SORRY_NO_RESULT_FOUND, THREE_DASH, TRY_SEARCHING_WITH_ANOTHER_KEYWORD } from "./commonNames";

export const notFound = {
    dataNotFound: SORRY_NO_RESULT_FOUND,
    nullData: THREE_DASH,
    notAvailable: NA,
    somethingWrong: SOMETHING_WENT_WRONG,
    thereIsNoDataFound: NO_DATA_FOUND_PLEASE_TRY_AGAIN,
    trySearchingWithAnotherKeyword: TRY_SEARCHING_WITH_ANOTHER_KEYWORD,
  };

  export const checkStatusCodeSuccess = (data: any) => {
    if (data === StatusCodes.OK || data === StatusCodes.ACCEPTED || data === StatusCodes.CREATED) {
      return true;
    } else {
      return false;
    }
  };

  export const SESSION_SET_ITEM = (key:string, value:string) => {
    sessionStorage.setItem(key, value);
  };

  export const SESSION_GET_TOKEN = ()=>{
    const getKey = sessionStorage.getItem("authToken")
    
    return getKey;
  }

  export const SESSION_GET_ITEM = (key: string)=>{
    const getKey = sessionStorage.getItem(key)
    return getKey;
  }

  export const SESSION_REMOVE_ITEM = ()=>{
     sessionStorage.clear()

  }
